import React from 'react';

import CustomComponent from '../CustomComponent';

import { convertStyleData } from '@utils/tools';
import { pageMethod  } from '@utils/page';

import './SidebarCustomComponent.less';

export default class SidebarCustomComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  tapMaskCloseSidebar = () => {
    const props = this.props;
    const componentIndex = props.index;
    pageMethod.setCustomComponentData(componentIndex, { ...props.data, hideSidebar: true });
    setTimeout(() => {
      pageMethod.setCustomComponentData(componentIndex, { ...props.data, showSidebar: false });
    }, 300);
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    const detailData = this.props.detailData;    // 详情页数据
    const dynamicData = this.props.dynamicData;  // 动态数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    styleObj['animation'] = `${data.hideSidebar ? 'hide' : 'show'}${customFeature.direction === 'left' ? 'Left' : 'Right'}Sidebar .3s forwards`;
    const maskStyleObj = {
      backgroundColor: customFeature.maskBackgroundColor,
      opacity: customFeature.maskOpacity,
    }
    /**
     * 组件内容处理
     */   
    let content = data.content;
    const segment = data.customFeature.segment; // 已绑定字段
    // 是否有绑定字段
    if (segment) {
      if (detailData && detailData[segment]) {
        content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
      } else if (dynamicData && dynamicData[segment]) {
        content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
      }
    }
    /**
     * 返回组件
     */
    if (!data.showSidebar) {
      return null;
    }
    return (
      <div className="custom-component sidebar" >
        <div className="sidebar-mask" style={maskStyleObj} onClick={() => this.tapMaskCloseSidebar()}></div>
        <div className="sidebar-content" style={styleObj}>
          {content.map((componentData, componentIndex) => 
            <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData}/>
          )}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/sidebar-custom-component/SidebarCustomComponent.jsx